
<template>
<section>
  <div class="columns">
    <div class="col">
      <chc-input v-model="data.first_name" :error="errors.first_name" label="First Name" :required="true"></chc-input>
      <chc-input v-model="data.last_name"  :error="errors.last_name" label="Last Name" :required="true"></chc-input>
      <chc-input v-model="data.email" label="Email" :error="errors.email" :required="true"></chc-input>
      <chc-input v-model="data.user_role" label="User Type" format="combo"
                 :error="errors.user_role"
                 :autoCompleteValues="$store.state.constants.users.user_types"
                 :required="true"></chc-input>

      <chc-input v-model="data.mobile" label="Phone"
                 :error="errors.mobile"
                 v-show="data.user_role == 'admin'"
                 :required="true"></chc-input>

      <chc-input v-model="data.charity_id" label="Charity"
                 :error="errors.charity_id"
                 v-if="data.user_role == 'charity'"
                 :autoCompleteValuesHidden="$store.state.summary.charities"
                 :autoCompleteValues="$store.state.summary.charities_active" format="combo"
                 :required="true"></chc-input>

      <chc-input v-model="data.charity_id" label="Charity"
                 :error="errors.charity_id"
                 v-if="data.user_role == 'charity_prospect'"
                 :autoCompleteValuesHidden="$store.state.summary.charities"
                 :autoCompleteValues="$store.state.summary.charities_prospect" format="combo"
                 :required="true"></chc-input>

      <chc-input v-model="data.call_center_id" label="Call Center"
                 v-if="data.user_role == 'call'"
                 :error="errors.call_center_id"
                 :autoCompleteValues="$store.state.summary.call_centers" format="combo"
                 :required="true"></chc-input>

      <span v-if="hasErrors" class="error-message error-block">
        There were errors processing the form. Please fix the fields above.
      </span>
      <div class="field submit-section">
        <input @click="submit" type="submit" class="btn" value="Save Changes">
      </div>
    </div>
  </div>
</section>
</template>

<script>
import store from '@/store'

export default {
  name: 'UsersAdd',
  data () {
    return {
      data: {
        first_name: '',
        last_name: '',
        email: '',
        user_role: '',
        charity_id: '',
        call_center_id: ''
      },
      errors: {},
      hasErrors: false
    }
  },
  props: [],
  methods: {
    submit () {
      store.functions.users.createUser(
        this.data,
        (errors) => {
          this.errors = errors
          this.hasErrors = true
        })
        .then(() => {
          this.hasErrors = false
          this.$router.push({name: 'UsersSummary'})
          this.$emit('refresh')
          this.$emit('close')
        })
    }
  },
  computed: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/UsersAdd.vue